import { ViewModel, View, ObservableArray } from "binder"
import { ToolValidStatusManipulationView } from "./toolValidStatusManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ToolValidStatusEditorViewModel } from "./toolValidStatusEditor/toolValidStatusEditor-viewModel";
import { IToolValidStatus } from "./IToolValidStatus";
import { ToolStatusMultiSelectorViewModel } from "./toolStatusMultiSelector";

export class ToolValidStatusManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'وضعیت ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolValidStatus = ObservableArray.create<ToolValidStatus>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolValidStatusManipulationView();
    }
    public getTypeId(): string {
        return "VM-3C10FA52-0B1A-4302-BB3F-7622E5A394EF"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolValidStatus(v: ObservableArray<ToolValidStatus>) { this._toolValidStatus = v; } public get toolValidStatus(): ObservableArray<ToolValidStatus> { return this._toolValidStatus; } private _toolValidStatus: ObservableArray<ToolValidStatus>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolStatusServices/ListAllToolValidStatuses', {
                FilteringInformation: filteringInformation
            });
            this.toolValidStatus.update(...result.ToolValidStatuses.map((x, i) => {
                let statusNames = [];
                let t = new ToolValidStatus(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.Id;
                t.toolTypeName = x.ToolTypeName;
                t.toolModelId = x.ToolModelId;
                t.toolModelName = x.ToolModelName;
                t.toolModelCode = x.ToolModelCode;
                t.toolStatuses.update(...x.ToolStatuses.map((item) => {
                    let i = new ToolStatusesViewModel(this);
                    i.id = item.Id;
                    i.statusCode = item.StatusCode;
                    i.statusName = item.StatusName;
                    i.toolStatusListId = item.ToolStatusListId;
                    statusNames.push(item.StatusName);
                    t.statusText = statusNames.join(" - ");
                    return i;
                }));
                t.setToolStatusListIds(x.ToolStatuses.map(y => y.ToolStatusListId));
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async edit(toolValidStatus: IToolValidStatus) {
        let popup = new ToolValidStatusEditorViewModel(this);
        await toolValidStatus.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }
}

export class ToolValidStatus extends ViewModel implements IToolValidStatus {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolValidStatusManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.toolStatusSelector = new ToolStatusMultiSelectorViewModel(this);
        this.toolStatuses = ObservableArray.create<ToolStatusesViewModel>();
    }

    private _typedParent: ToolValidStatusManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelCode(v: string) { this._toolModelCode = v; } public get toolModelCode(): string { return this._toolModelCode; } private _toolModelCode: string;
    public set toolStatusSelector(v: ToolStatusMultiSelectorViewModel) { this._toolStatusSelector = v; } public get toolStatusSelector(): ToolStatusMultiSelectorViewModel { return this._toolStatusSelector; } private _toolStatusSelector: ToolStatusMultiSelectorViewModel;
    public set toolStatuses(v: ObservableArray<ToolStatusesViewModel>) { this._toolStatuses = v; } public get toolStatuses(): ObservableArray<ToolStatusesViewModel> { return this._toolStatuses; } private _toolStatuses: ObservableArray<ToolStatusesViewModel>;
    public set statusText(v: string) { this._statusText = v; } public get statusText(): string { return this._statusText; } private _statusText: string;

    setToolStatusListIds(value: string[]) {
        this.toolStatusSelector.selectById(value);
    }
    getToolStatusListIds(): string[] {
        return this.toolStatusSelector.selectedItems.map(x => x.id);
    }

    setToolStatusIds(value: string[]) {
        throw new Error("Method not implemented.");
    }
    getToolStatusIds(): string[] {
        return this.toolStatuses.map(q => q.id);
    }

    async cloneTo(toolValidStatus: IToolValidStatus) {
        toolValidStatus.id = this.id;
        toolValidStatus.toolTypeName = this.toolTypeName;
        toolValidStatus.toolModelId = this.toolModelId;
        toolValidStatus.toolModelName = this.toolModelName;
        toolValidStatus.toolModelCode = this.toolModelCode;
        toolValidStatus.setToolStatusIds(this.getToolStatusIds());
        toolValidStatus.setToolStatusListIds(this.getToolStatusListIds());
    }

    async edit() {
        this._typedParent.edit(this);
    }
}

export class ToolStatusesViewModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set statusCode(v: string) { this._statusCode = v; } public get statusCode(): string { return this._statusCode; } private _statusCode: string;
    public set statusName(v: string) { this._statusName = v; } public get statusName(): string { return this._statusName; } private _statusName: string;
    public set toolStatusListId(v: string) { this._toolStatusListId = v; } public get toolStatusListId(): string { return this._toolStatusListId; } private _toolStatusListId: string;
}
